import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const updateSuspend=({
    smasterId,
    suspend
},token)=>async dispatch=>{
    dispatch({
        type:actionTypes.UPDATE_SUSPEND_START,
    })
    const options={
        url:`${api}/smasters/${smasterId}/suspend`,
        method:'PUT',
        headers:{
            Authorization:`Bearer ${token}`
        },
        data:{
            suspend
        }
    }
    await axios(options)
        .then(response=>dispatch({
            type:actionTypes.UPDATE_SUSPEND_SUCCESS,
            payload:response.data
        }))
        .catch(error=>dispatch({
            type:actionTypes.UPDATE_SUSPEND_FAIL,
            payload:getMessage(error)
        }))
}